export default {
  toggleLoadingWarehouses(state, toggleLoadingWarehouses) {
    state.loadingWarehouses = toggleLoadingWarehouses;
  },

  setWarehouseConfigs(state, newWarehouseConfigs) {
    state.warehouses = newWarehouseConfigs;
  },

  toggleModalLoading(state, newModalLoading) {
    state.currentModalLoading = newModalLoading;
  },
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/store/mutations.js